import classNames from "classnames";

const COMPARISON_STRINGS = {
  include: {
    exact: "is",
    starts_with: "starts with",
    ends_with: "ends with",
    includes: "contains",
    regex: "matches regular expression",
  },
  exclude: {
    exact: "is not",
    starts_with: "does not start with",
    ends_with: "does not end with",
    includes: "does not contain",
    regex: "fails regular expression",
  },
};

export function PrettyPrintCondition({ definition, condition }) {
  switch (condition.type) {
    case "utm":
    case "custom": {
      const { param, value } = condition.data;
      return (
        <>
          Parameter <Parameter name="Parameter" value={param} bold required />{" "}
          {value ? (
            <span>
              equals <Parameter name="Value" value={value} bold />
            </span>
          ) : (
            "is empty"
          )}
        </>
      );
    }
    case "referral_domain": {
      const { domain } = condition.data;
      return (
        <>
          Visitor was referred from{" "}
          <Parameter name="Domain" value={domain} bold required />
        </>
      );
    }
    case "url":
    case "path": {
      const { mode, comparison, value } = condition.data;
      const comparisonText =
        COMPARISON_STRINGS[mode]?.[comparison] ?? `${mode} ${comparison}`;
      return (
        <>
          {condition.type === "path" ? "Path" : "URL"}{" "}
          <Parameter name="Mode" value={comparisonText} bold />{" "}
          <Parameter name="Value" value={value} bold required />
        </>
      );
    }
    case "returning": {
      const { value } = condition.data;
      return (
        <>
          Visitor is{" "}
          <Parameter name="Value" value={value ? "returning" : "new"} bold />
        </>
      );
    }
    case "date_range": {
      const { start, end, timezone } = condition.data;
      return (
        <>
          Today is between{" "}
          <Parameter name="Start Date" value={start} bold required /> and{" "}
          <Parameter name="End Date" value={end} bold required /> in{" "}
          <Parameter name="Timezone" value={timezone} required />
        </>
      );
    }
    case "time_range": {
      const { start, end, timezone } = condition.data;
      return (
        <>
          The time is between{" "}
          <Parameter name="Start Time" value={start} bold required /> and{" "}
          <Parameter name="End Time" value={end} bold required /> in{" "}
          <Parameter name="Timezone" value={timezone} required />
        </>
      );
    }
    case "day_of_week": {
      const { day, timezone } = condition.data;
      return (
        <>
          The day is <Parameter name="Day" value={day} bold required /> in{" "}
          <Parameter name="Timezone" value={timezone} required />
        </>
      );
    }
    default:
      return <span className="italic font-bold">Unknown condition</span>;
  }
}

function Parameter({ name, value, bold, required = false }) {
  return (
    <span
      className={classNames(
        "py-0.5 px-1 border border-primary rounded bg-white whitespace-nowrap",
        bold && "font-bold"
      )}
    >
      {required && !value ? (
        <span className="italic text-lightRedHover">missing value</span>
      ) : (
        value
      )}
    </span>
  );
}
